import { createContext } from 'react';
import { media } from '@vaettyr/boltcave-media-client';

type fallbackContext = {
    images: media[]
}

export default createContext<fallbackContext>({ images: [] });
